export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail o username',
      invalidEmailOrUsername: 'E-mail or username invalido',
      invalidPassword: 'Password non valida',
      logInToPlanka: 'Log in Planka',
      noInternetConnection: 'Nessuna connessione internet',
      pageNotFound_title: 'Pagina non trovata',
      password: 'Password',
      projectManagement: 'Project management',
      serverConnectionFailed: 'Connesione al server fallita',
      unknownError: 'Errore sconosciuto, prova ancora',
    },

    action: {
      logIn: 'Log in',
    },
  },
};
